import { getTHERMSImageThumbnailUrl } from "../../../Files/utils/get-therms-image-thumbnail-url.js";
import { AppShellViewModel } from "../../viewmodels/AppShellViewModel.js";
import { SidePanelViewModel } from "../../viewmodels/SidePanelViewModel.js";
import logoIso_default from "../../../../assets/Images/logoIso.png.js";
import { AppPicker } from "./components/AppPicker.js";
import { OrgInfo } from "./components/OrgInfo.js";
import { StatusPill } from "./components/StatusPill.js";
import { navBackground } from "./nav-background.js";
import "react";
import { Avatar, Image } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
// src/modules/AppWrapper2/components/AppNav/AppNavMobile.tsx
function AppNavMobile() {
	const shellVM = useSingleton(AppShellViewModel);
	const panelVM = useSingleton(SidePanelViewModel);
	const user = shellVM.user;
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface-strong gap-x-sm px-sm py-xs relative flex w-full items-center",
		style: navBackground(shellVM.currentApp?.color),
		children: [
			/* @__PURE__ */ jsx(Image, {
				className: "w-xl",
				fit: "cover",
				lazy: false,
				src: logoIso_default
			}),
			shellVM.appList.length > 1 && /* @__PURE__ */ jsx(AppPicker, { compact: true }),
			shellVM.organization && /* @__PURE__ */ jsx(OrgInfo, { compact: true }),
			/* @__PURE__ */ jsx("div", { className: "grow" }),
			/* @__PURE__ */ jsx(StatusPill, {}),
			/* @__PURE__ */ jsx(Avatar, {
				circular: true,
				onClick: () => panelVM.openTo("user"),
				size: "xxs",
				statusColor: user?.status?.color,
				url: getTHERMSImageThumbnailUrl(user?.avatarUrl)
			})
		]
	});
}
export { AppNavMobile };

//# sourceMappingURL=AppNavMobile.js.map